// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"Payment_contentContainer__1v6z0","sidenavContainer":"Payment_sidenavContainer__LngcO","paymentTitle":"Payment_paymentTitle__2XrbL"};